export const cxxJasTranslations = {
  CXX_JAS_TITLE: 'Tranzer JAS subscription',
  CXX_JAS_SUBTITLE: 'How does the JAS subscription work?',
};
